import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, Platform, Modal } from 'react-native';
import { Button, Input, Routes, Screen, NavigationComponent } from '../components';
import { SignUpPaymentInput, SignUpPriceSelection, SignUpUserInfo } from '../containers';
import AuthController from '../controllers/authController';
import UserController from '../controllers/userController';
import { StringUtils } from '../utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { config } from '../../config';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WebView } from 'react-native-webview';

class SignUpScreen_Base extends Component {

  constructor(props) {
    super(props);

    let step = props.step ? (props.step === 'plan_selection' ? 'selection' : props.step) : 'user_info'

    this.state = {
      display_section: step, // 'payment' 'selection' 'user_info'
      selected_duration: 'month',
      selected_price: 0,
      monthly_price: null,
      monthly_price_id: null,
      yearly_price: null,
      yearly_price_id: null,
      display_webview: false,
      email: ''
    }

    this.userSignUpComplete = this.userSignUpComplete.bind(this);
    this.subscriptionComplete = this.subscriptionComplete.bind(this);
    this.selectPrice = this.selectPrice.bind(this);
    this.closeStripeView = this.closeStripeView.bind(this);
  }

  navigate = () => {
    if(Platform.OS === 'web') {
      return this.props.navigate;
    } else {
      return this.props.navigation.push;
    }
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  async componentDidMount() {
    let user         = await AuthController.getUser();
    let sub_response = await AuthController.getSubscription({ partner_name: config.SELECTED_PARTNER });
    let session_id   = await AuthController.startSignupSession();

    let sub_success  = sub_response && sub_response.success      ? true : false;
    let subscription = sub_success  && sub_response.subscription ? sub_response.subscription : null;
    let sign_up_step = this.state.display_section;
    /* let sign_up_step = await AsyncStorage.getItem('subscription_sign_up_step');
        sign_up_step = user && user.last_signup_screen && user.last_signup_screen === 'subscription_choice' ? 'selection' : sign_up_step;

    if(!sign_up_step) {
      sign_up_step = 'user_info'
    } */

    if(!subscription) {
      subscription = {
        subscription_amount_month: config.subscription_amount_month,
        subscription_amount_month_price_id: config.subscription_amount_month_price_id,
        subscription_amount_six_months: config.subscription_amount_six_months,
        subscription_amount_six_months_monthly_preview: config.subscription_amount_six_months_monthly_preview,
        subscription_amount_six_months_price_id: config.subscription_amount_six_months_price_id,
        subscription_amount_year: config.subscription_amount_year,
        subscription_amount_year_monthly_preview: config.subscription_amount_year_monthly_preview,
        partner_id: config.partner_id
      }
    }

    let monthly_price   = StringUtils.getPriceFromCents(subscription.subscription_amount_month);
    let monthly_price_id = subscription.subscription_amount_month_price_id;

    let six_month_price = StringUtils.getPriceFromCents(subscription.subscription_amount_six_months);
    let six_month_price_id = subscription.subscription_amount_six_months_price_id;

    let six_month_mo_preview = StringUtils.getPriceFromCents(subscription.subscription_amount_six_months_monthly_preview);
    let yearly_price    = StringUtils.getPriceFromCents(subscription.subscription_amount_year);
    let year_mo_preview = StringUtils.getPriceFromCents(subscription.subscription_amount_year_monthly_preview);

    this.setState({ monthly_price, yearly_price, six_month_price, six_month_mo_preview, year_mo_preview, partner_id: subscription.partner_id, selected_price: monthly_price, selected_price_id: monthly_price_id, monthly_price_id, six_month_price_id, yearly_price_id: null });

    // Make sure we have a user if redirected to a different section manually through url
    if(sign_up_step !== 'user_info') {
      if(!user || !user.token) {
        sign_up_step = 'user_info'
      }
    }

    if(sign_up_step === 'selection') {
      this.setState({ display_section: 'selection' })
    } else {
      this.setState({
        display_section: sign_up_step,
        partner_id: await AsyncStorage.getItem('partner_id')
      })
    }

    await AuthController.updateCareSignUpSession({ has_entered_phone_input_screen: true });
  }

  async userSignUpComplete(user_info) {
    await AsyncStorage.setItem('subscription_sign_up_step', 'selection');

    if (Platform.OS === 'web') {
      var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?step=plan_selection';
      window.history.pushState({ path: refresh }, '', refresh);
    }

    if (Platform.OS === 'web') {
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');

       fbq('init', '1421996844904147');
       fbq('track', 'CompleteRegistration');
    } else {
      /* let FBSDK = require("react-native-fbsdk-next");
      let { AppEventsLogger } = FBSDK;
      AppEventsLogger.logEvent(AppEventsLogger.AppEvents.CompletedRegistration, {
        [AppEventsLogger.AppEventParams.RegistrationMethod]: "email",
      })
      AppEventsLogger.flush() */
    }

    let user_email = user_info && user_info.email ? user_info.email : '';

    this.setState({display_section: 'selection', email: user_email })
  }

  async subscriptionComplete(has_existing_subscription) {
    await AsyncStorage.removeItem('sign_up_step');
    await AsyncStorage.removeItem('subscription_sign_up_step');

    if (has_existing_subscription) {
      await AuthController.updateCareSignUpSession({ has_existing_subscription: true });
    } else {
      await AuthController.updateCareSignUpSession({ has_subscribed_successfully: true });
    }

    if (Platform.OS === 'web') {
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');

       fbq('init', '1421996844904147');
       fbq('track', 'Subscribe');
    } else {
      /* let FBSDK = require("react-native-fbsdk-next");
      let { AppEventsLogger } = FBSDK;
      AppEventsLogger.logEvent(AppEventsLogger.AppEvents.Subscribe, {
        [AppEventsLogger.AppEventParams.Currency]: "usd",
      })
      AppEventsLogger.flush() */
    }

    // if (Platform.OS === 'web') {
    //   ire('trackConversion', '33211',
    //     {
	  //       orderId: "",
    //       customerId: "",
    //       customerEmail: "",
    //     },
    //     {
    //       verifySiteDefinitionMatch:true
    //     }
    //   );
    // }

    if(Platform.OS === 'web') {
      this.props.onSignIn(true);
      this.props.navigate(`${Routes.WEB_LANDING}`);
    } else {
      this.props.navigation.push(Routes.HOME)
    }
  }

  back_button_action = () => {
    let current_display_section = this.state.display_section;

    let new_display_section = current_display_section === 'selection' ? 'user_info' : new_display_section;
        new_display_section = current_display_section === 'payment'   ? 'selection' : new_display_section;

    if (current_display_section === 'user_info') {
      this.goBack();
    } else {
      this.setState({ display_section: new_display_section })
    }
  }

  render_webview_modal = () => {
    return <Modal
      animationType="slide"
      transparent={true}
      visible={ this.state.display_webview }
      onRequestClose={() => {
        this.setState({ display_webview: false, webview_url: '' })
      }}>
        <Screen navigation={this.props.navigation} title={'Payment Details'} right_action={this.closeStripeView} modal={true}>
          <WebView
            enableApplePay={true}
            style={styles.pdf_view_container}
            source={{ uri: this.state.webview_url }}
          />
        </Screen>
    </Modal>
  }

  async closeStripeView() {

    let partner_id      = await AsyncStorage.getItem('partner_id');
    let response = await UserController.checkSubscription({partner_id });

    console.log('subscriptionresponse', response);

    if(response.success && response.has_active_subscription) {
      await this.subscriptionComplete()
    }

    this.setState({
      display_webview: false
    });
  }

  async selectPrice() {
    let partner_id = this.state.partner_id;
    let price_id = this.state.selected_price_id;
    let cancel_url;
    let success_url;
    let redirect_domain = config.app_domain;
    let email = await AsyncStorage.getItem('email');
    let stored_click_id = await AsyncStorage.getItem('impact_click_id');
    let impact_click_id = stored_click_id || '';

    if (this.state.email) {
      email = this.state.email;
    }

    let platform_str = 'Unspecified';
        platform_str = Platform.OS === 'web'     ? 'Web Browser' : platform_str;
        platform_str = Platform.OS === 'ios'     ? 'iOS App'     : platform_str;
        platform_str = Platform.OS === 'android' ? 'Android App' : platform_str;

    if(Platform.OS === 'web') {
      cancel_url = `${redirect_domain}/sign_up?step=plan_selection`;
      success_url = `${redirect_domain}/web_landing`;
    } else {
      cancel_url = `${redirect_domain}/empty_page?content=Payment Cancelled`;
      success_url = `${redirect_domain}/empty_page?content=Payment Successful`;
    }

    await AsyncStorage.setItem('first_sign_up', 'true');
    this.setState({ loading_stripe_page: true });

    let res = await AuthController.createCheckoutSession({price_id, partner_id, cancel_url, success_url, email, platform: platform_str, impact_click_id: impact_click_id });

    console.log('data', res)

    this.setState({ loading_stripe_page: false });

    if(res.success && res.url) {
      if(Platform.OS === 'web') {
        window.location.replace(res.url);
      } else {
        this.setState({
          display_webview: true,
          webview_url: res.url
        })
      }
    }
  }

  render() {
    return (
      <Screen navigation={this.props.navigation} scroll={true} bg_white={true} left_action={this.back_button_action}>
        {this.render_webview_modal()}
            <SignUpUserInfo
              on_subscription_exists={this.subscriptionComplete}
              display={ this.state.display_section === 'user_info' }
              continue_btn_action={this.userSignUpComplete}
            />

            <SignUpPriceSelection
              monthly_price={this.state.monthly_price}
              monthly_price_id={this.state.monthly_price_id}
              yearly_price={this.state.yearly_price}
              six_month_price={this.state.six_month_price}
              six_month_price_id={this.state.six_month_price_id}
              year_mo_preview={this.state.year_mo_preview}
              six_month_mo_preview={this.state.six_month_mo_preview}
              display={ this.state.display_section === 'selection' }
              selected_duration={this.state.selected_duration}
              continue_btn_loading={this.state.loading_stripe_page}
              on_change_duration={ (new_duration) => {
                let selected_price = new_duration === 'year' ? this.state.yearly_price : (new_duration === 'month' ? this.state.monthly_price : this.state.six_month_price);

                let selected_price_id = new_duration === 'year' ? this.state.yearly_price_id : (new_duration === 'month' ? this.state.monthly_price_id : this.state.six_month_price_id);

                this.setState({ ...this.state, selected_duration: new_duration, selected_price, selected_price_id })
              }}
              continue_btn_action={ async () => {
                let selected_price = this.state.selected_price;
                await AuthController.updateCareSignUpSession({ has_selected_plan: true, selected_plan: selected_price.toString() });
                this.selectPrice();
              }}
            />

            <SignUpPaymentInput
              navigation={this.props.navigation}
              price={this.state.selected_price}
              update_payment_method={AuthController.createSubscription}
              period={this.state.selected_duration}
              partner_id={this.state.partner_id}
              display={this.state.display_section === 'payment' }
              continue_btn_action={this.subscriptionComplete}
            />
      </Screen>
    );
  }
}

function SignUpScreen(props) {
  if(Platform.OS === 'web') {
    let navigate = useNavigate();
    const [searchParams] = useSearchParams();

    let step = searchParams.get('step');
    return  <SignUpScreen_Base {...props} step={step} navigate={navigate} />
  } else {
    //navigate={props.navigation.push}
    return  <SignUpScreen_Base {...props}  />
  }
}

const styles = StyleSheet.create({

});

export default SignUpScreen
